import GetMissionary from '../components/GetMissionary';

export default function PersonalData() {
  return (
    <div>
      <GetMissionary />
    </div>
  );
}
